import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Translate, withLocalize } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../../store/storeFunctions';

import SemRColor from '../../../../img/repi/semaphore_negative_color';
import SemGColor from '../../../../img/repi/semaphore_positive_color';
import SemAColor from '../../../../img/repi/semaphore_neutral_color';
import SemRBw from '../../../../img/repi/semaphore_negative_bw';
import SemGBw from '../../../../img/repi/semaphore_positive_bw';
import SemABw from '../../../../img/repi/semaphore_neutral_bw';

import '../../repi.scss';

class RepiSemaphore extends React.Component {
    render() {
        const { semaphore } = this.props;

        if (isNullOrUndefined(semaphore))
            return null;

        const value = ["R", "A", "G"].includes((semaphore.value || "").toUpperCase()) ? semaphore.value.toUpperCase() : "A";

        return (
            <div className="repi-rga-container">
                <div className="repi-rga-image">
                    {value === "G" ? <SemGColor /> : <SemGBw />}
                    {value === "A" ? <SemAColor /> : <SemABw />}
                    {value === "R" ? <SemRColor /> : <SemRBw />}
                </div>
                <div className="repi-rga-description">
                    <Translate id={`Repi.Report.Semaphore.${value}`} />
                </div>
            </div>
        );
    }
}

export default connect(
    state => state.userContext,
    null
)(withLocalize(withRouter(RepiSemaphore)));
